<template>
  <in-out-stock stock-type="in" />
</template>

<script>
import InOutStock from '@/views/wms/stock/InOutStock.vue'

export default {
  name: 'instock',
  components: {
    InOutStock,
  },
}
</script>
